export enum GameOutcome {
    None = 0,
    Up = 1,
    Down = -1
}